<template>
<div class="bg">
    <div class="banner"><img src="../assets/imgs/bg.jpg" /></div>
    <div class="contant">
        <ul class="clearfix">
            <li class="fl" v-for="(item,index) in infoList" :key="index" :class="{active1:isActive==index}" @click="tabChange(index)">{{item}}</li>
            <li class="fr">
                <button  type="button" class="btn btn-default" @click="contype">个人信息表</button>
                <button type="button" class="btn btn-default"  @click="modal1 = true">回到首页</button>
            </li>
        </ul>
     <Modal
      v-model="modal1"
      title="系统提示"
      @on-ok="ok"
      @on-cancel="cancel">
      <h4>确定要退出吗？</h4>
    </Modal>
        <!-- 个人信息 -->
        <person-info v-if="isActive == 0"></person-info>
        <!-- 院系信息 -->
        <department-info v-if="isActive == 1"></department-info>
        <!-- 家属信息 -->
        <family-info v-if="isActive == 2"></family-info>
        <!-- 宿舍信息信息 -->
        <room-info v-if="isActive == 3"></room-info>
        <!-- 延迟报到 -->
        <delay-report-info v-if="isActive == 4"></delay-report-info>
    </div>
    <!-- 提示框   -->
    <tip :tip="tip" v-show="tipShow"></tip>
</div>
    
</template>

<script>
import personInfo from "@/components/personInfo";
import departmentInfo from "@/components/departmentInfo";
import familyInfo from "@/components/familyInfo";
import roomInfo from "@/components/roomInfo";
import delayReportInfo from "@/components/delayReportInfo";
let Base64 = require("js-base64").Base64;
export default {
  components: {
    delayReportInfo,
    roomInfo,
    personInfo,
    departmentInfo,
    familyInfo
  },
  data() {
    return {
      modal1: false, //对话框
      infoList: ["个人信息", "院系专业", "家属信息", "宿舍分配", "延迟报到"], //信息列表
      isActive: 0, //判断Tab是否被激活
      tipShow: false, //tip提示
      tip: "", //tip提示信息
      src: "", //头像默认地址
      errImg: 'this.src="' + require("../assets/imgs/tx.png") + '"'
    };
  },
  created() {},
  mounted() {},
  methods: {
    //切换tab
    tabChange(item) {
      this.isActive = item;
    },
    // 对话框
    ok() {
      this.getBack();
      this.modal1 = false;
    },
    cancel() {
      this.modal1 = false;
    },
    contype() {
      this.$router.push({ path: "/stuInfoing" });
    },
    //返回首页
    // 推出事件
    getBack() {
      this.$router.back();
      sessionStorage.clear();
    },
    //提示框方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    }
  }
};
</script>

<style>
.bg {
  background: rgb(248, 248, 248);
  height: 100%;
}
.banner {
  width: 100%;
  min-width: 800px;
  height: 350px;
  overflow: hidden;
}
.banner img {
  vertical-align: middle;
}
.bRed {
  border: 1px solid #f00 !important;
}
/***内容***/
.contant {
  width: 1000px;
  min-height: 800px;
  padding: 0 20px;
  margin: -100px auto 100px;
  background: #fff;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #fff;
  box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.2);
}

.active1 {
  background: #4e6ae4;
  padding: 5px 15px;
  color: white !important;
}
.contant > ul {
  margin-top: 20px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
}
.contant > ul > li:not(:last-child) {
  margin: 0 10px;
  font-size: 16px;
  padding-top: 6px;
  color: #333;
}
.contant > ul > li:not(:last-child):hover {
  cursor: pointer;
}
.btn-default {
  margin-right: 20px;
}
.clearfix .fl {
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/view/basicInfo.vue